module.exports = __webpack_public_path__ + "img/leftside_1000.140c7a32.png";